import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function systemInfoReducer(
    state: any = initialState.systemInfo,
    action: { type: string; systemInfo: any }
) {
    switch (action.type) {
        case types.LOAD_SYSTEM_INFO_SUCCESS: {
            return {
                ...action.systemInfo
            };
        }
        default:
            return state;
    }
}

const getSystemInfo = (state) => state.systemInfo;
export const getSystemVersion = (state) => getSystemInfo(state).version;
